import React, { useEffect, useState } from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { operacion } from '../../models/operacion';
import Button from '../../../../components/inputs/yup/Button';
import CustomTooltip from '../../../../components/ui/materialui/customToolTip';
import { Card, CardContent, Grid2, Typography } from '@mui/material';
import InputNumber from '../../../../components/inputs/yup/materialui/inputNumber';
import ErrorIcon from '@mui/icons-material/Error';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import { selectorTransversal } from '../../../../dtos/selector';
interface IRefinanciamiento {
    control: Control<operacion>;
    watch: UseFormWatch<operacion>;
    setValue: UseFormSetValue<any>
    refinanciamiento: selectorTransversal[]
    isEditing: boolean;
    errors: FieldErrors<operacion>;
    isComplementario: boolean;
     isReadonlyWithPermission : () => boolean;
}

const RefinanciamientoForm: React.FC<IRefinanciamiento> = ({ control, watch, setValue, refinanciamiento, isEditing, errors, isComplementario, isReadonlyWithPermission }) => {

    const dataRefinancimiento = watch();

    const handleCalcularMontoFinesGenerales = async () => {

        const gastosOperacioneles = dataRefinancimiento.gastosOperacionales ? dataRefinancimiento.gastosOperacionales : 0;
        const montoLey = dataRefinancimiento.refinancMontoLey != null ? dataRefinancimiento.refinancMontoLey : 0;
        const divsFuturosBanco = dataRefinancimiento.refinancDivsFuturosBanco != null ? dataRefinancimiento.refinancDivsFuturosBanco : 0;

        let nuevoMontoFinesGenerales: number = 0;
        if (dataRefinancimiento.esGastosIncluidosCredito)
            nuevoMontoFinesGenerales = dataRefinancimiento.montoCredito - gastosOperacioneles - montoLey - divsFuturosBanco;

        else
            nuevoMontoFinesGenerales = dataRefinancimiento.montoCredito - montoLey - divsFuturosBanco;

        setValue("refinancGenerales", nuevoMontoFinesGenerales.toFixed(4))
    }

    useEffect(() => {

        handleCalcularMontoFinesGenerales();

    }, [dataRefinancimiento.montoCredito,
    dataRefinancimiento.gastosOperacionales,
    dataRefinancimiento.refinancMontoLey,
    dataRefinancimiento.refinancDivsFuturosBanco,
    dataRefinancimiento.esGastosIncluidosCredito]);

    return (
        <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
            <CardContent>
                <Typography className='card-title' variant="h6" gutterBottom>
                    Datos de refinanciamiento
                </Typography>
                <Grid2 container spacing={2} sx={{ mt: 2 }}>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label='Refinanciamiento'
                            name='refinanciamiento'
                            control={control}
                            options={refinanciamiento}
                            readonly={isReadonlyWithPermission()}
                            error={errors.refinanciamiento}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Monto cert. de ley 20.130"
                            name="refinancMontoLey"
                            control={control}
                            prefix="UF"
                            readonly={isReadonlyWithPermission()}
                            error={errors.refinancMontoLey}
                            decimales={4}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Provisión banco"
                            name="refinancProvBanco"
                            control={control}
                            prefix="CLP"
                            readonly={isReadonlyWithPermission()}
                            error={errors.refinancProvBanco}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label={
                                <>
                                    Divs futuros banco alzante{" "}
                                    <CustomTooltip text="Incluida en el crédito">
                                        <ErrorIcon />
                                    </CustomTooltip>
                                </>
                            }
                            name="refinancDivsFuturosBanco"
                            control={control}
                            prefix="UF"
                            readonly={isReadonlyWithPermission()}
                            error={errors.refinancDivsFuturosBanco}
                            decimales={4}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Fines generales cliente"
                            name="refinancGenerales"
                            control={control}
                            prefix="UF"
                            readonly={isReadonlyWithPermission()}
                            error={errors.refinancGenerales}
                            decimales={4}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    );
};

export default RefinanciamientoForm;